import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { clearanceAPI } from '../../lib/clearanceAPI';
import { errText } from '../../lib/lettersAPI';

const ITEM_ST = [['requested', 'Requested'], ['received', 'Received'], ['not_applicable', 'Not applicable'], ['outstanding', 'Outstanding']];

export const RecordsTransferPanel = ({ c, me, reload }) => {
  const rt = c.records_transfer;
  const run = (fn, ok) => async () => { try { await fn(); if (ok) toast.success(ok); reload(); } catch (e) { toast.error(errText(e)); } };
  if (!rt) return me.can_edit && c.authority_ok && ['accept', 'accept_mitigation'].includes(c.decision?.decision)
    ? <Button size="sm" variant="outline" onClick={run(() => clearanceAPI.startTransfer(c.id), 'Records transfer started')} data-testid={`pc-start-transfer-${c.id}`}>Request records transfer</Button> : null;
  const upload = (iid) => async (e) => { const f = e.target.files?.[0]; if (!f) return; const fd = new FormData(); fd.append('file', f);
    try { await clearanceAPI.itemDoc(iid, fd); toast.success('Document linked'); reload(); } catch (err) { toast.error(errText(err)); } };
  const locked = rt.status === 'complete';
  return (
    <div className="rounded-md border p-2 space-y-1 text-xs" data-testid={`pc-transfer-${c.id}`}>
      <div className="flex items-center justify-between"><span className="font-medium">Records transfer – {locked ? 'Handover complete' : 'Open'}</span>
        {!locked && me.can_edit && <Button size="sm" variant="outline" onClick={run(() => clearanceAPI.completeTransfer(rt.id), 'Handover confirmed complete')} data-testid={`pc-transfer-complete-${c.id}`}>Confirm handover complete</Button>}</div>
      {rt.items.map((i) => (
        <div key={i.id} className="flex flex-wrap items-center gap-2" data-testid={`pc-item-${i.id}`}>
          <span className="flex-1 min-w-[180px]">{i.name}</span>
          <select disabled={locked || !me.can_edit} className="border rounded p-1" value={i.status} onChange={(e) => run(() => clearanceAPI.updateItem(i.id, { status: e.target.value }))()} data-testid={`pc-item-status-${i.id}`}>
            {ITEM_ST.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
          {(i.documents || []).map((d) => <span key={d.document_id} className="text-emerald-700">{d.filename}</span>)}
          {!locked && me.can_edit && <Input type="file" className="h-7 w-48 text-xs" onChange={upload(i.id)} data-testid={`pc-item-upload-${i.id}`} />}
        </div>))}
    </div>
  );
};
